import { useQueryClient } from '@tanstack/react-query';
import { useCallback, useMemo } from 'react';
import { SearchModality } from '../feature/search-table-company/hooks/types';
import { useModalityChangeCounterStore } from '../store/modality-change-counter';
import { useSearchQueryFilter } from './use-search-query-filter';

export function useSearchModality() {
  const { setParam, params } = useSearchQueryFilter({
    select: ['modality'],
  });
  const { incrementCounter, counter } = useModalityChangeCounterStore();
  const queryClient = useQueryClient();

  const setModality = useCallback(
    (modality: SearchModality) => {
      setParam('modality', modality);

      // =======================================================
      // below code is here in order to refetch search queries on each modality change
      // step 1: get all cached queries for the given modality
      const cachedQueries = queryClient.getQueryCache().findAll({
        stale: false,
        predicate: (query) => query.queryKey.includes(counter[modality]),
      });

      // step 2: if there are cached queries, increment the counter (so the cached query will be refetched)
      // if there are no cached queries, the query will be refetched anyway
      if (cachedQueries.length !== 0) {
        incrementCounter(modality);
      }
      // =======================================================
    },
    [setParam, incrementCounter, counter, queryClient]
  );

  const modality = useMemo(
    () => (params.modality as SearchModality) ?? SearchModality.TOTAL,
    [params.modality]
  );

  return { modality, setModality };
}
